/* It's a modal that allows the user to create a new form */
import axios from "axios"
import React, { Component } from "react"
import { Button, FormControl, Modal, Spinner } from "react-bootstrap"
import Select from "react-select"
import DynamicFormPaletteTypes from "src/store/DyanmicFormPalette/types"
import AxiosConfig from "src/utilities/AxiosConfig"
import DynamicFormTypes from "../Types/DynamicFormsTypes"
import formBoiler from "../Utils/FormBoiler"
import referenceHelper from "../Utils/ReferenceHelper"
import saveSetUp from "../Utils/SaveSetup"
import stateMutator from "../Utils/StateMutator"
import "./CreateDynamicForm.css"

interface Props {
    formTypes: Array<{ CustomFormTypeId: number, Type: string }>
    manageParentState: Function
    callParentFunction: Function
    userId: string | number
    palette: Array<DynamicFormPaletteTypes>
}

interface State {
    form: DynamicFormTypes
    input: string
    eventType: string
    busy: boolean
}

class CreateDynamicForm extends Component<Props, State> {

    state = {
        form: formBoiler,
        input: "",
        eventType: "",
        busy: false
    }

    /* A function that is used to update the state. It is used to prevent the state from being updated in
    an uncontrolled manner. */
    manageState = (keys: Array<{ key: string, value?: any }>) => {
        this.setState(stateMutator.mutate(this.state, keys))
    }

    handleChange = (event: { target: { value: any } }) => {
        const input = event.target.value
        let temp = this.state.form
        temp[this.state.eventType] = input
        this.manageState([{ key: "form", value: temp }])
    }

    /* A function that is called when the user clicks the save button. It sets the state to busy, then it
    calls the saveSetUp function to set up the form to be saved. Then it calls the API to save the form.
    If the save is successful, it sets the state to not busy and calls the parent function to get the
    forms. If the save is not successful, it sets the state to not busy and calls the parent function to
    get the forms. */
    saveForm = () => {
        this.manageState([{ key: "busy", value: true }])
        const form = saveSetUp.setUpSave(this.state.form, [], this.props.userId, this.props.palette, true, true)
        axios.post(process.env.REACT_APP_API_URL + "/api/company/AddEditDynamicForm", form, AxiosConfig.configValue("min"))
            .then((res: any) => {
                this.manageState([{ key: "busy", value: false }])
                this.props.manageParentState([{ key: "createForm", value: null }])
                this.props.callParentFunction("getDynamicForms", true, true)
            }).catch((err: any) => {
                this.manageState([{ key: "busy", value: false }])
                this.props.manageParentState([{ key: "createForm", value: null }])
                this.props.callParentFunction("getDynamicForms", false, false)
            })
    }

    render() {

        const state = this.state
        const props = this.props
        const canCreate = this.state.form.Name && this.state.form.CustomFormTypeId

        return (
            <div className="CreateDynamicForm">
                <Modal
                    id="create-dynamic-form-modal"
                    show={true}
                    backdrop="static"
                    keyboard={true}
                    centered={true}
                >
                    <Modal.Header>
                        <div className="CreateDynamicFormModalHeader">
                            <span className="material-icons">dynamic_feed</span>
                            <p>Create a new form...</p>
                        </div>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="CreateDynamicFormModalBody">
                            <div className="CreateDynamicFormModalBodyItem">
                                <div className="CreateDynamicFormModalBodyItemHeader">
                                    <p>Name</p>
                                </div>
                                <FormControl onFocus={() => this.manageState([{ key: "eventType", value: "Name" }])}
                                    onChange={this.handleChange}
                                    value={state.form.Name || ""}
                                    type="text"
                                />
                            </div>
                            <div className="CreateDynamicFormModalBodyItem">
                                <div className="CreateDynamicFormModalBodyItemHeader">
                                    <p>Type</p>
                                </div>
                                <Select
                                    placeholder={"Form Type"}
                                    //@ts-ignore
                                    value={{ label: referenceHelper.getFormTypeRefDataById(state.form.CustomFormTypeId, props.formTypes).Type }}
                                    options={props.formTypes.map((item) => ({ value: item.CustomFormTypeId, label: item.Type }))}
                                    onChange={(item: {value: string, label: string}) => {
                                        let temp = this.state.form
                                        //@ts-ignore
                                        temp.CustomFormTypeId = item.value
                                        this.manageState([{ key: "form", value: temp }])
                                    }}
                                />
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <div className="CreateDynamicFormModalFooter">
                            {state.busy && <div className="CreateDynamicFormModalFooterBusy">
                                <Spinner animation="border" />
                            </div>}
                            {!state.busy && <div className="CreateDynamicFormModalFooterNotBusy">
                                <Button variant="secondary" onClick={() => this.props.manageParentState([{ key: "createForm", value: null }])}>Cancel</Button>
                                <Button id="create-dynamic-form-modal-footer-not-busy-create-btn" disabled={!canCreate} onClick={() => this.saveForm()}>Save</Button>
                            </div>}
                        </div>
                    </Modal.Footer>
                </Modal>
            </div>
        )
    }
}

export default CreateDynamicForm